export const deliveryMenus = {
	Store: [{
			action: 'zmdi-store',
			title: 'message.profile',
			// active: false,
			label: 'Old',
			exact: true,
			path: '/delivery-profile'
		},
		/*{
			action: 'zmdi-shopping-cart',
			title: 'message.purchasesToVerify',
			active: false,
			label: 'Old',
			path: '/shopping-list',
			exact: true
		},*/
		{
			action: 'zmdi-local-shipping',
			title: 'message.shippings',
			exact: false,
			//path: '/delivery-shippings',
			label: 'Old',
			items: [{
					title: 'message.verify',
					// active: false,
					label: 'Old',
					path: '/delivery-shopping-list',
					exact: true
				},
				{
					title: 'message.verifieds',
					// active: false,
					label: 'Old',
					path: '/delivery-shippings',
					exact: true
				}
			]
		},
		{
			action: 'zmdi-swap-alt',
			title: 'message.routes',
			exact: true,
			path: '/delivery-shipping-routes',
			label: 'Old'
		},
		{
			action: 'zmdi-run',
			title: 'message.dealers',
			exact: true,
			path: '/delivery-dealers',
			label: 'Old'
		},
		{
			action: 'zmdi-mall',
			title: 'message.linkedStores',
			exact: true,
			path: '/delivery-linked-stores',
			label: 'Old'
		},
		{
			action: 'zmdi-balance',
			title: 'message.paymentMethods',
			// active: false,
			label: 'Old',
			path: '/delivery-bank-list',
			exact: true
		},
		{
			action: 'zmdi-file-text',
			title: 'message.reports',
			// active: false,
			label: 'Old',
			path: '/delivery-reports',
			exact: true
		},
	]
}